import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { Dialog } from '../components/DialogOld';
import { saveOutlet } from '../actions/SaveOutlet';
import { createOutlet } from '../actions/CreateOutlet';
import { deleteOutlet } from '../actions/DeleteOutlet';
import { FormRow } from '../components/FormRow';
import { FormGroup } from '../components/FormGroup';
import { hideDialog } from '../reducers/app';
import { RadioButtons } from '../components/RadioButtons';
import { isOutletKind, setEditOutletDialogCodeAddItem, setEditOutletDialogCodeDeleteItem, setEditOutletDialogCodeUnit, setEditOutletDialogCodeValue, setEditOutletDialogComment, setEditOutletDialogKind, setEditOutletDialogTitle } from '../reducers/edit_outlet_dialog';
const DeleteButton = (props) => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }));
const CancelButton = (props) => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }));
const SaveButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }));
const CreateButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa uttag" }));
const CodeRow = (props) => {
    var _a, _b;
    return (_jsxs("div", { style: { display: 'grid', gridTemplateColumns: '6fr 5fr 1fr', paddingTop: '1px' }, children: [_jsx("div", { style: { paddingRight: '15px', paddingBottom: '3px' }, children: _jsx("input", { type: "number", min: "0", name: 'code_' + props.index, value: (_a = props.item.code) !== null && _a !== void 0 ? _a : '', onChange: event => props.updateCode(event.target.value) }) }), _jsx("div", { style: { paddingRight: '15px', paddingBottom: '3px' }, children: _jsx("input", { type: "number", min: "0", name: 'unit_' + props.index, value: (_b = props.item.unit) !== null && _b !== void 0 ? _b : '', onChange: event => props.updateUnit(event.target.value) }) }), _jsx("div", { children: _jsx("button", { type: "button", className: "close", "aria-label": "Close", style: { paddingTop: '5px' }, onClick: () => props.deleteItem(), children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) }) })] }));
};
const CodeRows = () => {
    const dispatch = useAppDispatch();
    const dialog = useAppSelector(state => state.edit_outlet_dialog);
    function deleteItem(index) {
        dispatch(setEditOutletDialogCodeDeleteItem(index));
    }
    function addItem() {
        dispatch(setEditOutletDialogCodeAddItem());
    }
    function updateCode(index) {
        return (v) => dispatch(setEditOutletDialogCodeValue({ index, code: parseInt(v) }));
    }
    function updateUnit(index) {
        return (v) => dispatch(setEditOutletDialogCodeUnit({ index, unit: parseInt(v) }));
    }
    const rows = dialog.codes.map((codeItem, index) => (_jsx(CodeRow, { index: index, item: codeItem, deleteItem: () => deleteItem(index), updateCode: updateCode(index), updateUnit: updateUnit(index) }, codeItem.key)));
    return (_jsxs("div", { children: [_jsxs("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', paddingTop: '5px' }, children: [_jsx("label", { className: "grouptitle", style: { whiteSpace: 'nowrap' }, children: "Kod" }), _jsx("label", { className: "grouptitle", style: { whiteSpace: 'nowrap' }, children: "Enhet" })] }), rows, _jsx("div", { children: _jsx("button", { className: "lw success add-code", type: "button", "aria-label": "Add", style: { paddingTop: '5px' }, onClick: () => addItem(), children: _jsx("span", { "aria-hidden": "true", children: "Add" }) }) })] }));
};
export const DialogOutletEdit = () => {
    const dispatch = useAppDispatch();
    const dialog = useAppSelector(state => state.edit_outlet_dialog);
    let footerleft, footerright;
    if (dialog.id) {
        footerleft = [
            (_jsx(DeleteButton, { onClick: () => { if (dialog.id !== null) {
                    dispatch(deleteOutlet(dialog.id));
                } } }, "delete"))
        ];
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(SaveButton, { onClick: () => dispatch(saveOutlet(dialog)) }, "save"))
        ];
    }
    else {
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(CreateButton, { onClick: () => dispatch(createOutlet(dialog)) }, "create"))
        ];
    }
    const radiobuttons = [
        { kind: 'onoff', title: 'På/Av' },
        { kind: 'dim', title: 'Dimmer' },
        { kind: 'rollershade', title: 'Rullgardin' }
    ];
    function setKind(v) {
        if (isOutletKind(v)) {
            dispatch(setEditOutletDialogKind(v));
        }
    }
    return (_jsxs(Dialog, { id: "outlet-edit", title: "Redigera uttag", footerleft: footerleft, footerright: footerright, children: [_jsx(FormRow, { children: _jsx(FormGroup, { label: "Namn", children: _jsx("input", { type: "text", name: "title", value: dialog.title, onChange: event => dispatch(setEditOutletDialogTitle(event.target.value)) }) }) }), _jsx(FormRow, { children: _jsx(RadioButtons, { buttons: radiobuttons, name: 'kind', kind: dialog.kind, updateKind: v => setKind(v) }) }), _jsx(FormRow, { children: _jsx(CodeRows, {}) }), _jsx(FormRow, { children: _jsx(FormGroup, { label: "Kommentar", children: _jsx("input", { type: "text", name: "comment", value: dialog.comment, onChange: event => dispatch(setEditOutletDialogComment(event.target.value)) }) }) })] }));
};
